import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db, auth } from '../config/firebase';

// Track any event
export const trackEvent = (eventName, parameters = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, parameters);
  }
};

// Specifically for tracking clicks
export const trackClick = async (elementType, elementName, page, additionalData = {}) => {
  try {
    const userId = auth.currentUser?.uid || 'anonymous';
    const userEmail = auth.currentUser?.email || 'anonymous';

    await addDoc(collection(db, 'clickEvents'), {
      userId,
      userEmail,
      elementType, // 'button' or 'link'
      elementName,
      page,
      timestamp: serverTimestamp(),
      ...additionalData
    });
  } catch (error) {
    console.error('Error tracking click:', error);
  }
}; 